import type {
  BetterstartCommandRuntime,
  ListIntegrationsCommandOptions
} from '@cli-types/core-engine/commands.js'
import { Command } from 'commander'

export function createListIntegrationsCommand(runtime: BetterstartCommandRuntime): Command {
  return new Command('list-integrations')
    .description('List available BetterStart integrations')
    .option('--json', 'Print integrations as JSON on stdout', false)
    .option('--cwd <path>', 'Project root path')
    .action((options: ListIntegrationsCommandOptions) => runtime.runListIntegrations(options))
}
